import { SettingOutlined } from '@ant-design/icons'
import { Popconfirm, Popover } from 'antd'
import React, { useEffect, useState } from 'react'
import { Link, useHistory } from 'react-router-dom'
import TableBox from '../../../../Components/TableBox/TableBox'
import FilterLayout from '../../../../Layout/FilterLayout'
import TableLayout from '../../../../Layout/TableLayout'
import apiClient from '../../../../Util/apiClient'
import { GET_DATA, SET_DATA, validateAccess } from '../../../../Util/Util'
import OperationFilter from './OperationFilter'

export default function Operations() {
  const [operations, setOperations] = useState([])
  const history = useHistory()

  const getData = (params = {}) => {
    const filterCache = GET_DATA('operations.filterData') || {}
    params = { ...filterCache, ...params }

    apiClient.get('operations', { params }).then(({ status, data }) => {
      if (status === 200) {
        SET_DATA('operations.filterData', { ...params, ...data.pageData })
        setOperations(data.result)
      }
    })
  }

  useEffect(() => {
    getData()
  }, [])

  const onDelete = (id) => {
    apiClient.delete(`operations/${id}`).then(({ status }) => {
      if (status === 204) {
        setOperations(operations.filter((item) => item.id !== id))
      }
    })
  }

  const tableActions = (row) => (
    <div className="action-buttons">
      <ul>
        {validateAccess('edit-operation') && (
          <li>
            <Link to={`/app/edit-operation/${row.id}`}>
              <i className="flaticon-edit-1" /> Edit
            </Link>
          </li>
        )}
        {validateAccess('edit-operation') && (
          <li>
            <Popconfirm title="Sure to delete?" onConfirm={() => onDelete(row.id)}>
              <Link to="#">
                <i className="flaticon-delete-2" /> Delete
              </Link>
            </Popconfirm>
          </li>
        )}
      </ul>
    </div>
  )

  const columns = [
    {
      title: 'Type',
      dataIndex: 'type'
    },
    {
      title: 'Value',
      dataIndex: 'value'
    },
    {
      title: 'Description',
      dataIndex: 'description'
    },
    {
      title: 'Action',
      dataIndex: 'custom_action',
      render: (text, row) => (
        <Popover placement="bottomRight" content={tableActions(row)} trigger="click">
          <div className="btn-group">
            <button type="button" className="btn glow dropdown-toggle">
              <SettingOutlined /> <span className="caret" />
            </button>
          </div>
        </Popover>
      )
    }
  ]

  return (
    <FilterLayout
      addButton={{
        title: 'Operation',
        onClick: () => history.push('/app/add-operation'),
        access: 'add-operation'
      }}
      filterData={GET_DATA('operations.filterData')}
      filter={<OperationFilter onSubmit={getData} />}>
      <TableLayout title="Operations Overview" exportUrl="operations/export">
        <TableBox
          dataSource={operations}
          columns={columns}
          pageData={GET_DATA('operations.filterData')}
          onChangePage={getData}
        />
      </TableLayout>
    </FilterLayout>
  )
}
